/* eslint-disable */
import { ReactElement, useState, useEffect } from "react";
import { FileOutlined } from "@ant-design/icons";
import * as React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../stores/root-store-context";
import Spinner from "Components/Spinner/Spiner";
import ResponsiveGrid from '../../../../../../../../Components/TableMui/ResponsiveGrid';
import { useGridPagination } from "../helpers/useGridPagination";

const DATE_SORT_FIELDS = {
    originalDocumentDate: "originalDocumentDate",
};

const LotDocuments = observer((): ReactElement => {
    const { ricStore } = useStore();
    const [isLoadingLotDocs, setIsLoadingLotDocs] = useState<boolean>(false);

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US').format(date);
    };

    const columns = [
        {
            field: "localName",
            label: "Name",
            flex: 1.4,
            minWidth: 180,
            render: (value: string, row: any) => (
                <a
                    href={row.fullPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{ color: "#1677ff", cursor: "pointer" }}
                >
                    {value}
                </a>
            ),
        },
        { field: "documentType", label: "Doc Type", flex: 1, minWidth: 120 },
        {
            field: "originalDocumentDate",
            label: "Date",
            flex: 0.9,
            minWidth: 110,
            render: (value: string) => formatDate(value),
        },
        { field: "address", label: "Address", flex: 1.2, minWidth: 150 },
        { field: "residentAccount", label: "Resident Account", flex: 1, minWidth: 140 },
    ];

    const rows = React.useMemo(() => ricStore.lotDocuments ?? [], [ricStore.lotDocuments]);
    const { pagedRows, server } = useGridPagination(rows, { dateFields: DATE_SORT_FIELDS });

    const gridRef = React.useRef<HTMLDivElement>(null);
    const [visible, setVisible] = React.useState(true);

    React.useEffect(() => {
        const el = gridRef.current;
        if (!el) return;
        const observer = new ResizeObserver(() => setVisible(el.offsetWidth > 0));
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const companyKey = ricStore.accountInformation?.companyKey;
    const accountNumber = ricStore.accountInformation?.accountNumber;

    useEffect(() => {
        // Wait until the account is loaded; otherwise the search is sent with "undefined"
        if (!companyKey || !accountNumber) return;

        const loadDocuments = async () => {
            setIsLoadingLotDocs(true);
            try {
                await ricStore.getLotDocuments({
                    CommunityId: `${companyKey}`,
                    Office: ``,
                    filters: [`ResidentAccount:(\"${accountNumber}\")`],
                    searchText: null
                });
            } finally {
                setIsLoadingLotDocs(false);
            }
        };
        loadDocuments();
    }, [ricStore, companyKey, accountNumber]);

    return (
        <>
            {isLoadingLotDocs && <Spinner />}
            <div ref={gridRef} className="ric-pane">
                <ResponsiveGrid
                    key={visible ? "visible" : "hidden"}
                    columns={columns}
                    rows={pagedRows}
                    getRowId={(row) => row.fullPath}
                    loading={isLoadingLotDocs}
                    emptyText="No data."
                    emptyIcon={<FileOutlined />}
                    server={server}
                />
            </div>
        </>
    );
});

export default LotDocuments;